import { DEFAULT_PARAMS } from '@/utils/objectsRHandler';
import { rHandler } from '@/plugins/RHandler';
import { apiService } from '@/services/APIService';

const API_PATH_UPLOAD = 'upload';

export const UploadManager = {
  upload: ({ data, headers } = DEFAULT_PARAMS) => {
    const path = `${API_PATH_UPLOAD}s`;

    return rHandler(
      apiService.post(path, data, headers),
      (response) => ({ response }),
      (error) => ({ error }),
    );
  },
};
